import { render, staticRenderFns } from "./scp.vue?vue&type=template&id=0df012c8&scoped=true&"
import script from "./scp.vue?vue&type=script&lang=js&"
export * from "./scp.vue?vue&type=script&lang=js&"
import style0 from "./scp.vue?vue&type=style&index=0&id=0df012c8&prod&scoped=true&lang=scss&"
import style1 from "./scp.vue?vue&type=style&index=1&id=0df012c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df012c8",
  null
  
)

export default component.exports